import { html } from "htm/preact";
import { hydrate } from "preact";
import PagefindTrigger, { initPagefind } from "../components/PagefindTrigger.js";

// iOS Safari scroll lock: prevents the page body from scrolling under the modal.
// overflow: hidden on body is insufficient on iOS; position: fixed is required.
let savedScrollY = 0;

const lockBodyScroll = () => {
  savedScrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.width = "100%";
};

const unlockBodyScroll = () => {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo(0, savedScrollY);
};

const setupScrollLock = (modal) => {
  const attachDialogObserver = (dialog) => {
    const dialogObserver = new MutationObserver(() => {
      if (dialog.open) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });
    dialogObserver.observe(dialog, { attributes: true, attributeFilter: ["open"] });
  };

  const dialog = modal.querySelector("dialog.pf-modal");
  if (dialog) {
    attachDialogObserver(dialog);
    return;
  }

  // Dialog not yet rendered — wait for the custom element to add it
  const waitObserver = new MutationObserver(() => {
    const dialog = modal.querySelector("dialog.pf-modal");
    if (dialog) {
      waitObserver.disconnect();
      attachDialogObserver(dialog);
    }
  });
  waitObserver.observe(modal, { childList: true, subtree: true });
};

const triggers = document.querySelectorAll("[data-search-trigger-island]");

triggers.forEach((el) => {
  // 1. First, we initialize Pagefind
  if (typeof initPagefind === "function") {
    initPagefind();
  }

  // 2. Then we check if the modal template is already in the DOM, if not, we add it
  const template = document.getElementById("pf-modal-template");
  if (template && !document.getElementById("opcl-search-modal")) {
    document.body.appendChild(template.content.cloneNode(true));
  }

  // 3. Set up iOS Safari scroll lock for when the search modal is open
  const modal = document.getElementById("opcl-search-modal");
  if (modal) {
    setupScrollLock(modal);
  }

  const searchLabel = el.dataset.searchLabel || "Search";

  hydrate(html`<${PagefindTrigger} searchLabel=${searchLabel} />`, el);
});